import { render } from "./PRO_Produse.vue?vue&type=template&id=1fa5b194&scoped=true&ts=true"
import script from "./PRO_Produse.vue?vue&type=script&lang=ts"
export * from "./PRO_Produse.vue?vue&type=script&lang=ts"

import "./PRO_Produse.vue?vue&type=style&index=0&id=1fa5b194&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa5b194"]])

export default __exports__